/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PubListConfigReplacements
 */
export interface PubListConfigReplacements  {
    /**
     * 
     * @type {string}
     * @memberof PubListConfigReplacements
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof PubListConfigReplacements
     */
    value?: string;
}

/**
 * Check if a given object implements the PubListConfigReplacements interface.
 */
export function instanceOfPubListConfigReplacements(value: object): value is PubListConfigReplacements {
    return true;
}

export function PubListConfigReplacementsFromJSON(json: any): PubListConfigReplacements {
    return PubListConfigReplacementsFromJSONTyped(json, false);
}

export function PubListConfigReplacementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PubListConfigReplacements {
    if (json == null) {
        return json;
    }
    return {
        
                  'key': json['key'] == null ? undefined : json['key'],
                  'value': json['value'] == null ? undefined : json['value'],
    };
}

export function PubListConfigReplacementsToJSON(json: any): PubListConfigReplacements {
    return PubListConfigReplacementsToJSONTyped(json, false);
}

export function PubListConfigReplacementsToJSONTyped(value?: PubListConfigReplacements | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}


